import type { SVGProps } from 'react';

interface SalesTrackingIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function SalesTrackingIcon({ className, ...props }: SalesTrackingIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6.50098 7.34375L6.33105 7.97461H10.8906L3.87305 15.9209L5.54297 10.541L5.74414 9.89355H1.09375L7.94824 1.97656L6.50098 7.34375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
